"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FidelityReportGroup = _interopRequireDefault(require("../FidelityReportGroup"));
var _reactRedux = require("react-redux");
var _summaryFidelityAdapter = require("../../reducers/summaryFidelityAdapter.js");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _SummaryReportToolbar = _interopRequireDefault(require("../SummaryReportToolbar"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _first2 = _interopRequireDefault(require("lodash/first"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _remove2 = _interopRequireDefault(require("lodash/remove"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var headerMatch = {
  SummaryReportToolbar: _SummaryReportToolbar["default"]
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    sessions: state.impact.summaryFidelityAdapter.data,
    loading: state.impact.summaryFidelityAdapter.loading,
    response: state.impact.summaryFidelityAdapter.response
  };
};
var SummaryFidelityAdapter = /*#__PURE__*/function (_Component) {
  _inherits(SummaryFidelityAdapter, _Component);
  function SummaryFidelityAdapter() {
    var _this;
    _classCallCheck(this, SummaryFidelityAdapter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SummaryFidelityAdapter, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.getData(_this.props);
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.resetState();
    });
    _defineProperty(_assertThisInitialized(_this), "processFields", function () {
      var formattedFields = [];
      _this.props.headerFields.fields.forEach(function (field) {
        var newField = field;
        if (field.from === 'graphql') {
          newField.value = (0, _get2["default"])(_this.props.response, field.valuePath);
        } else {
          newField = (0, _cccisdLaravelAppdefs.displayFieldsHelper)({
            fields: [field]
          }, _this.props.entityProps.selectedEntity)[0];
        }
        formattedFields.push(newField);
      });
      var participatingIndividuals = 0;

      // provider
      var base = (0, _get2["default"])(_this.props.response, _this.props.basePath);
      var children = (0, _get2["default"])(base, _this.props.childrenPath);
      children.forEach(function (child) {
        participatingIndividuals += parseInt((0, _get2["default"])(child, _this.props.participantCountPath), 10);
      });
      formattedFields.push({
        label: 'Participating Individuals',
        value: participatingIndividuals
      });
      return formattedFields;
    });
    _defineProperty(_assertThisInitialized(_this), "processDatesOfService", function () {
      return {
        to: new Date(parseInt((0, _last2["default"])((0, _remove2["default"])((0, _map2["default"])(_this.props.sessions, 'lastDate'), function (elem) {
          return !(0, _isUndefined2["default"])(elem);
        }).sort()), 10)) * 1000,
        from: new Date(parseInt((0, _first2["default"])((0, _remove2["default"])((0, _map2["default"])(_this.props.sessions, 'firstDate'), function (elem) {
          return !(0, _isUndefined2["default"])(elem);
        }).sort()), 10)) * 1000
      };
    });
    return _this;
  }
  _createClass(SummaryFidelityAdapter, [{
    key: "render",
    value: function render() {
      var HeaderComponent = headerMatch[this.props.headerComponent];
      if (this.props.loading) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex',
            justifyContent: 'center'
          }
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: this.props.loading,
          type: "inline"
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(_FidelityReportGroup["default"], {
        sessions: this.props.sessions,
        header: /*#__PURE__*/_react["default"].createElement(HeaderComponent, {
          fields: this.processFields(),
          heading: "Fidelity Summary",
          datesOfService: this.processDatesOfService(),
          allSessionsNotHeldMissed: this.props.sessions.every(function (s) {
            return s.isHeldMissed === false;
          })
        }),
        reportProps: this.props.reportProps,
        comments: [],
        isReport: this.props.isReport
      });
    }
  }]);
  return SummaryFidelityAdapter;
}(_react.Component);
SummaryFidelityAdapter.propTypes = {
  // ---- common props
  query: _propTypes["default"].string,
  // the processed variables
  variables: _propTypes["default"].object,
  dataPath: _propTypes["default"].string,
  reportProps: _propTypes["default"].object,
  headerFields: _propTypes["default"].object,
  // flag to display as a pdf report or a browser view report
  isReport: _propTypes["default"].bool,
  // the pawn or group
  entity: _propTypes["default"].object,
  displaySettings: _propTypes["default"].object,
  acrossChildrenSettings: _propTypes["default"].object,
  metricsRenderers: _propTypes["default"].array,
  headerComponent: _propTypes["default"].string,
  entityProps: _propTypes["default"].object,
  devMetricsTags: _propTypes["default"].object,
  devMetricsPath: _propTypes["default"].string,
  // the handle of the report
  reportHandle: _propTypes["default"].string,
  // redux
  getData: _propTypes["default"].func,
  sessions: _propTypes["default"].array,
  loading: _propTypes["default"].bool,
  resetState: _propTypes["default"].func,
  response: _propTypes["default"].object,
  basePath: _propTypes["default"].string,
  childrenPath: _propTypes["default"].string,
  participantCountPath: _propTypes["default"].string
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  getData: _summaryFidelityAdapter.getData,
  resetState: _summaryFidelityAdapter.resetState
})(SummaryFidelityAdapter);